import { ReactElement } from "react"
import { Box, Grid, Typography } from "@mui/material"
import { DateRange } from "@mui/x-date-pickers-pro"
import { SwitchContainer } from "../components"
import InfoPopper from "../../../shared/UI/InfoPopper"
import { IOSStyleSwitch } from "../../../shared/UI/IOSStyleSwitch/IOSStyleSwitch"
import DateTimePicker from "../../../shared/UI/DateTimePicker"
import CheckBox from "../../../shared/UI/CheckBox"

interface PartDayAbsenceFormProps {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  popperText: ReactElement | string
  shiftDescription: string
  dateRange: DateRange<Date>
  absentFrom: Date
  hasHadLunch: boolean
  setHasHadLunch: (value: boolean) => void
  toWorkBack: boolean
  setToWorkBack: (value: boolean) => void
  setAbsentFromDate: (value: Date) => void
  disabledPartDayAbsence: boolean
  disabledAbsentFrom: boolean
  partDayAbsenceFromError?: boolean
}

function PartDayAbsenceForm({
  isOpen,
  setIsOpen,
  popperText,
  shiftDescription,
  dateRange,
  absentFrom,
  hasHadLunch,
  setHasHadLunch,
  toWorkBack,
  setToWorkBack,
  setAbsentFromDate,
  disabledPartDayAbsence,
  disabledAbsentFrom,
  partDayAbsenceFromError = false,
}: PartDayAbsenceFormProps): JSX.Element {
  return (
    <>
      <Grid item xs={12} md={12}>
        <SwitchContainer>
          <Box display="flex" alignItems="center">
            <Typography align="center" variant="body1">
              Part Day Absence
            </Typography>
            <InfoPopper popperText={popperText} style={{ marginLeft: '10px' }} />
          </Box>

          <IOSStyleSwitch
            checked={isOpen}
            name="partDayAbsence"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="MyActions-Absence-PartDayAbsence"
            disabled={disabledPartDayAbsence}
          />
        </SwitchContainer>
      </Grid>
      {isOpen ? (
        <>
          <Grid item xs={12} md={12}>
            <DateTimePicker
              label="Absent from"
              id="absentFrom"
              value={absentFrom}
              onChange={newValue => {
                if (!newValue) {
                  return
                }

                setAbsentFromDate(newValue)
              }}
              disabled={disabledAbsentFrom}
              dataTestId="MyActions-Absence-PartDayAbsence-DateTime"
              error={partDayAbsenceFromError}
            />
          </Grid>
          <Grid item xs={12} md={12} mt={-1}>
            <SwitchContainer>
              <CheckBox
                defaultChecked={hasHadLunch}
                label="Has had lunch"
                name="hasHadLunch"
                onChange={event => setHasHadLunch(event.target.checked)}
                dataTestId="MyActions-Absence-PartDayAbsence-hasHadLunch"
              />
            </SwitchContainer>
            <SwitchContainer>
              <CheckBox
                defaultChecked={toWorkBack}
                label="To work back"
                name="toWorkBack"
                onChange={event => setToWorkBack(event.target.checked)}
                dataTestId="MyActions-Absence-PartDayAbsence-ToWorkBack"
              />
            </SwitchContainer>
          </Grid>
        </>
      ) : (
        <Grid item xs={12} md={12}>
          <SwitchContainer>
            <CheckBox
              defaultChecked={toWorkBack}
              label="To work back"
              name="toWorkBack"
              onChange={event => setToWorkBack(event.target.checked)}
            />
          </SwitchContainer>
        </Grid>
      )}
    </>
  )
}

export default PartDayAbsenceForm